import { Skeleton } from '@/components';
import { Card, CardContent } from '@/components/atoms/Card/Card.tsx';
import { EDIT_CELL_METRICS_CARD_TEST_IDS } from '@/constants/data-testids';

type EditMetricsCellProps = {
  title: string;
};

export const EditMetricsCell = ({ title }: EditMetricsCellProps) => {
  return (
    <Card data-testid={EDIT_CELL_METRICS_CARD_TEST_IDS.WRAPPER} className="w-[352px] p-4">
      <CardContent>
        <p className="text-body-14-semibold !text-custom-warm-grey-700 mb-6">{title}</p>
        <div className="flex items-center gap-2">
          <Skeleton className="w-[72px] h-6 bg-custom-warm-grey-300" />
          <Skeleton className="w-10 h-4" />
        </div>
      </CardContent>
    </Card>
  );
};
